var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 30,
    viewBox: "0 0 44 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4C29.58 4 36.34 8.26 39.64 15C36.34 21.74 29.58 26 22 26C14.42 26 7.66 21.74 4.36 15C7.66 8.26 14.42 4 22 4ZM22 0C12 0 3.46 6.22 0 15C3.46 23.78 12 30 22 30C32 30 40.54 23.78 44 15C40.54 6.22 32 0 22 0ZM22 10C24.76 10 27 12.24 27 15C27 17.76 24.76 20 22 20C19.24 20 17 17.76 17 15C17 12.24 19.24 10 22 10ZM22 6C17.04 6 13 10.04 13 15C13 19.96 17.04 24 22 24C26.96 24 31 19.96 31 15C31 10.04 26.96 6 22 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/open_eye.7f06723c7779a3b86c9c49c5606bd93b.svg";
export { ForwardRef as ReactComponent };